module.exports = __webpack_public_path__ + "img/logo-feelgood-plus.d2ddcb44.png";